<template>
    <v-container class="overflow-hidden" style="background-color: black;" fluid>
        <v-row no-gutters>
          <v-col
            md="6"
          >
            <v-img 
            justify="center" 
            aspect-ratio="1.4" 
            :src="require('@/assets/cafe/tasas-leche.jpeg')" 
            />
          </v-col>

          <v-col
            class="align-content-space-between layout wrap"
            cols="12"
            md="6"
          >
            <v-row
              align="center"
              justify="center"
            >
              <v-col
                cols="10"
                md="6"
              >
                <h2 class="white--text text--lighten-1 text-uppercase">El mejor café!</h2>
                <p class="white--text text--lighten-1">
                  Lorem ipsum dolor sit amet, consectetur ad
                  ipiscin elit. Etiam vulputate augue vel felis gra
                  vida porta. Lorem ipsum dolor sit amet, cons
                  ectetur adipiscing elit.<br>
                  Lorem ipsum dolor sit amet, consectetur ad
                  ipiscin elit. Etiam vulputate augue vel felis gra
                  vida porta. Lorem ipsum dolor sit amet, cons
                  ectetur adipiscing elit.
                </p>
                <p class="white--text text--lighten-1">
                  Lorem ipsum dolor sit amet, consectetur ad
                  ipiscin elit. Etiam vulputate augue vel felis gra
                  vida porta. Lorem ipsum dolor sit amet, cons
                  ectetur adipiscing elit.<br>
                  Lorem ipsum dolor sit amet, consectetur ad
                  ipiscin elit. Etiam vulputate augue vel felis gra
                  vida porta. Lorem ipsum dolor sit amet, cons
                  ectetur adipiscing elit.
                </p>
                
                <div  style="padding-top: 12px">
                  <v-btn  :to="{name: 'Cafe'}" rounded color="secondary" dark>Ver todos</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
</template>
<script>
  export default {
    name: 'Coffes',

    data: () => ({
      features: [
          {
            img: require('../assets/Fiorella.png'),
            title: 'Fiorella',
            text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
          },
          // {
          //   img: require('../assets/Jonatan.png'),
          //   title: 'Jonatan',
          //   text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
          // }
        ]
    }),
  }
</script>
<style lang="scss">
.knowledge-promo-background .knowledge-heading {
  width: 37%;
  color: #fff;
  font-family: "BebasNeue-Bold" !important;
  font-size: 70px;
  font-weight: 400;
  line-height: 75px;
  text-transform: uppercase;
  position: absolute;
  float: left;
  margin: 15% 0 0 45%;
}
p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
</style>